// extracted by mini-css-extract-plugin
module.exports = {"layout":"layout_layout__0spdh","content":"layout_content__7oO1m"};